import React, { useState, useRef } from "react";
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { clearMessage } from "../../actions/message";
import { getCenters, deleteCenter } from "../../actions/center";
import { toast } from 'react-toastify';
import { Grid, IconButton, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DataGrid } from '@mui/x-data-grid';
import CenterModal from "./CenterModal/CenterModal"
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmDialog from "../ConfirmDialog";
import Filter from "../Filter";
import { DataGridPro, GridActionsCellItem, GridToolbarExport, GridToolbarContainer } from '@mui/x-data-grid-pro';
import "../../List.css";
import { getBankAccounts } from "../../actions/bankaccount";
import MenuList from '@mui/material/MenuList';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import ContentCut from '@mui/icons-material/ContentCut';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import ContentCopy from '@mui/icons-material/ContentCopy';
import ContentPaste from '@mui/icons-material/ContentPaste';
import Cloud from '@mui/icons-material/Cloud';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import HotelIcon from '@mui/icons-material/Hotel';
import SellIcon from '@mui/icons-material/Sell';
import ListIcon from '@mui/icons-material/List';
import { API_URL } from "../../services/api-uri";
import axios from "axios";
import CakeIcon from '@mui/icons-material/Cake';
import { relativeTimeRounding } from "moment/moment";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ListingMenu from "./ListingMenu";

const CentersManagement = (props) => {

  const dispatch = useDispatch();

  const { user: currentUser } = useSelector((state) => state.auth);
  const { centers: listCenters } = useSelector((state) => state.centers);
  const [filter, setFilter] = useState('');
  const [centerToDelete, setCenterToDelete] = useState(null);
  const [activeFilter, setActiveFilter] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [inactiveShow, setInactiveShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState(null);
  let centerLoaded = false;
  const searchBarHelper = "Search for a center..."
  const { bankaccounts: bankAccounts } = useSelector((state) => state.bankaccounts);
  const { message } = useSelector(state => state.message);

  const HandleFilter = (e) => { setFilter(e.toLowerCase()) }

  useEffect(() => {
    if (!centerLoaded) {
      dispatch(getBankAccounts())
      dispatch(getCenters()).then(() => {
        centerLoaded = true;
      }).catch(() => {
        setLoading(false);
      })
    }
  }, []);

  const updateModalShow = (show) => {
    dispatch(clearMessage());
    setModalShow(show)
  }

  const updateActiveFilter = (e) => {
    setActiveFilter(e.target.checked);
  }

  const updateSelectedCenter = (u) => {
    dispatch(clearMessage());
    setSelectedCenter(u)
  }

  const add_center = () => {
    dispatch(clearMessage());
    let center_tmp = null;

    updateModalShow(true);
    updateSelectedCenter(center_tmp);
  }

  const edit_center = (show, u) => {
    dispatch(clearMessage());
    updateModalShow(show);
    updateSelectedCenter(u);
  }

  console.log(listCenters)


  const columns = [
    { field: 'name', flex: 1 },
    {
      field: 'actions',
      type: 'actions',
      sortable: false,
      getActions: (params) => {

        return [
          <>
            {/* {listCenters ? <ListingMenu id_center={params.id} setLoading={setLoading} isAdmin={currentUser.type == 1} center_abv={listCenters.filter((c) => c.id == params.id)[0].abbreviation} center={listCenters.filter((c) => c.id == params.id)[0]} /> : <></>} */}

            {currentUser.type == 1 ?

              <IconButton aria-label="delete" onClick={() => {
                setCenterToDelete(params.id);
                setConfirmOpen(true);
              }}>
                <DeleteIcon />
              </IconButton>
              : <></>}

            <ConfirmDialog
              title="Delete Centre?"
              content="Are you sure you want to delete this centre?"
              open={confirmOpen}
              setOpen={setConfirmOpen}
              onConfirm={(result) => {

                if (result == true) {

                  dispatch(delete_center(centerToDelete))
                    .then(() => {
                      toast.success(`${'Centre deleted successfuly'}`);
                    })
                    .catch(() => {
                      toast.error(`${'An error occured while deleting the centre, please try again later'}`);
                    });
                }

              }}>
            </ConfirmDialog>
          </>
        ];
      }
    }
  ];

  const delete_center = (uid) => {
    if (uid > 0) {
      dispatch(deleteCenter(uid)).then(() => { })
        .catch(() => {
          toast.error(`${message}`)
        });
    }
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            fileName: 'centers',
            delimiter: ';',
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    );
  }

  //Click sur une ligne
  const handleRowClick = (params) => {
    if (params.id > 0) {
      edit_center(true, listCenters.filter((c) => c.id == params.id)[0])
    }
  };

  //Fonction de tri
  function filterCenters(centerDTO) {
    if (centerDTO.id > 0) {
      if (!centerDTO.active && activeFilter) {
        return false
      }

      if (currentUser.type == 2 && centerDTO.id != currentUser.idCenter) {
        return false
      }
      return centerDTO.name.toLowerCase().includes(filter) || centerDTO.name.toLowerCase().includes(filter)
    }
  }

  const DataGrid_ = styled(DataGrid)(({ theme }) => ({
    "& .MuiDataGrid-columnHeaders": { display: "none" },
    "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" },
  }));

  return currentUser ? (
    <div className="app-container">

      <h1>Centres management</h1>

      <Filter
        setSearchQuery={HandleFilter}
        searchQuery={filter}
        helper={searchBarHelper}
        setActive={updateActiveFilter}
        HideAddButton={currentUser.type != 1}
        addDataFunction={add_center}
      />
      <TableContainer component={Paper}>
        {listCenters && bankAccounts ?
          <div style={{ height: "100%", width: '100%' }}>
            <DataGrid_
              autoHeight="true"
              onRowClick={handleRowClick}
              rows={
                listCenters.filter(filterCenters).map((centerDTO) => {
                  centerDTO.name = `${centerDTO.name}`;
                  return centerDTO;
                })}
              columns={columns}
              getRowId={(row) => row.id}
              initialState={{ pinnedColumns: { right: ['actions'] } }}
              getRowClassName={(params) => {
                return `row-child-${(listCenters.filter((centerDTO) => centerDTO.id == params.id)[0].active ? "active" : "inactive")}`
              }}
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          </div> : <></>
        }
      </TableContainer>

      <CenterModal admin={currentUser.type == 1} show={modalShow} currentCenterDTO={selectedCenter} updateSelectedCenter={setSelectedCenter} onHide={() => updateModalShow(false)} />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

    </div>
  ) : <></>
}

export default CentersManagement